/* sg-offer — gallery + purchase selection controller (vanilla, progressive enhancement).
   Reads the Liquid-rendered pricing JSON island and swaps the active package/type,
   updating the displayed price/compare-at/per-day/% and the native cart form's variant + selling_plan. */
(function () {
  /* ── Gallery: desktop = single main image swapped by arrows/thumbs;
        mobile = native scroll-snap carousel whose thumbnails stay in sync. ── */
  function initGallery(section) {
    /* Desktop: main image + prev/next + thumbnail grid. */
    var dg = section.querySelector('[data-sg-gallery-d]');
    if (dg) {
      var dMain = dg.querySelector('[data-sg-main]');
      var dThumbs = Array.prototype.slice.call(dg.querySelectorAll('[data-sg-thumb]'));
      var dIndex = 0;
      var dShow = function (i) {
        var n = dThumbs.length;
        if (!n) return;
        dIndex = ((i % n) + n) % n;
        var thumb = dThumbs[dIndex];
        if (dMain && thumb) dMain.src = thumb.getAttribute('data-full');
        dThumbs.forEach(function (t, idx) {
          t.classList.toggle('is-active', idx === dIndex);
        });
      };
      dThumbs.forEach(function (t, idx) {
        t.addEventListener('click', function () {
          dShow(idx);
        });
      });
    }

    /* Mobile: scroll-snap track (swipe handled natively) + synced thumbnails. */
    var mg = section.querySelector('[data-sg-gallery-m]');
    if (mg) {
      var track = mg.querySelector('[data-sg-track]');
      var mThumbs = Array.prototype.slice.call(mg.querySelectorAll('[data-sg-mthumb]'));
      var mWrap = mThumbs.length ? mThumbs[0].parentElement : null;
      var setActiveM = function (i) {
        mThumbs.forEach(function (t, idx) {
          t.classList.toggle('is-active', idx === i);
        });
        /* Center the active thumb in the strip. Clamping at both ends means the
           strip stays put for the first thumbs and only moves once centering is possible. */
        var active = mThumbs[i];
        if (active && mWrap && mWrap.scrollWidth > mWrap.clientWidth) {
          var offset = active.getBoundingClientRect().left - mWrap.getBoundingClientRect().left;
          var target = mWrap.scrollLeft + offset - (mWrap.clientWidth - active.offsetWidth) / 2;
          var max = mWrap.scrollWidth - mWrap.clientWidth;
          mWrap.scrollTo({ left: Math.max(0, Math.min(target, max)), behavior: 'smooth' });
        }
      };
      mThumbs.forEach(function (t, idx) {
        t.addEventListener('click', function () {
          if (track) track.scrollTo({ left: track.clientWidth * idx, behavior: 'smooth' });
          setActiveM(idx);
        });
      });
      if (track) {
        /* Update per animation frame (not debounced to scroll-end) so the active
           thumb flips mid-swipe, in step with the visible slide. */
        var mIndex = 0;
        var ticking = false;
        track.addEventListener(
          'scroll',
          function () {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(function () {
              ticking = false;
              if (!track.clientWidth) return;
              var i = Math.round(track.scrollLeft / track.clientWidth);
              if (i !== mIndex) {
                mIndex = i;
                setActiveM(i);
              }
            });
          },
          { passive: true },
        );
      }
    }
  }

  /* ── Shipping countdown (port of TrustShippingCountdown): Berlin-time cutoffs,
        German holidays, "ships today/tomorrow" with a live HH:MM:SS countdown < 4h. ── */
  function initShipping(section) {
    var el = section.querySelector('[data-sg-shipping]');
    if (!el) return;
    var textEl = el.querySelector('[data-sg-shipping-text]');
    var lang = el.getAttribute('data-sg-lang') === 'en' ? 'en' : 'de';

    var CUTOFF = 18,
      SAT_CUTOFF = 14,
      SPECIAL_CUTOFF = 12,
      THRESHOLD_H = 4;
    var SPECIAL_DATES = ['12-24', '12-31'];
    var FIXED_HOLIDAYS = ['01-01', '01-06', '05-01', '10-03', '12-25', '12-26'];
    var VARIABLE_HOLIDAYS = {
      2026: ['01-16', '04-03', '04-06', '05-14', '05-25', '06-04', '08-15', '11-01'],
    };
    var L =
      lang === 'en'
        ? { today: 'today', tomorrow: 'tomorrow', ship: 'Ships' }
        : { today: 'heute', tomorrow: 'morgen', ship: 'Versand' };

    function berlinNow() {
      return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Berlin' }));
    }
    function pad(n) {
      return (n < 10 ? '0' : '') + n;
    }
    function mmdd(d) {
      return pad(d.getMonth() + 1) + '-' + pad(d.getDate());
    }
    function isHoliday(d) {
      var key = mmdd(d);
      if (FIXED_HOLIDAYS.indexOf(key) !== -1) return true;
      return (VARIABLE_HOLIDAYS[d.getFullYear()] || []).indexOf(key) !== -1;
    }
    function isShippingDay(d) {
      return d.getDay() !== 0 && !isHoliday(d);
    }
    function cutoffHour(d) {
      if (SPECIAL_DATES.indexOf(mmdd(d)) !== -1) return SPECIAL_CUTOFF;
      if (d.getDay() === 6) return SAT_CUTOFF;
      return CUTOFF;
    }
    function fmt(ms) {
      if (ms <= 0) return '00:00:00';
      var s = Math.floor(ms / 1000);
      return pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
    }
    function status(now) {
      var cutoff = new Date(now);
      cutoff.setHours(cutoffHour(now), 0, 0, 0);
      var ms = cutoff.getTime() - now.getTime();
      if (isShippingDay(now) && ms > 0) {
        return { show: true, day: 'today', countdown: ms / 3600000 < THRESHOLD_H, ms: ms };
      }
      var tom = new Date(now);
      tom.setDate(tom.getDate() + 1);
      if (isShippingDay(tom)) return { show: true, day: 'tomorrow', countdown: false };
      return { show: false };
    }
    function render() {
      var st = status(berlinNow());
      if (!st.show) {
        el.hidden = true;
        return;
      }
      el.hidden = false;
      var head = '<strong>' + L.ship + ' ' + L[st.day] + '</strong>';
      var html;
      if (st.countdown) {
        var cd = '<strong class="sg-offer__shipping-cd">' + fmt(st.ms) + '</strong>';
        html =
          lang === 'en'
            ? head + ' if you order within the next ' + cd
            : head + ', wenn du innerhalb von ' + cd + ' bestellst';
      } else {
        html = lang === 'en' ? head + ' if you order now' : head + ', wenn du jetzt bestellst';
      }
      if (textEl) textEl.innerHTML = html;
    }
    render();
    setInterval(render, 1000);
  }

  function init(section) {
    var dataEl = section.querySelector('[data-sg-offer-data]');
    if (!dataEl) return;
    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var buyLink = section.querySelector('[data-sg-buy]');
    var klarna = section.querySelector('[data-sg-klarna]');
    var subBadge = section.querySelector('[data-sg-badge-sub]');
    var delivery = section.querySelector('[data-sg-delivery]');
    var deliveryFirst = section.querySelector('[data-sg-first]');
    var deliverySubsequent = section.querySelector('[data-sg-subsequent]');
    var discountNote = section.querySelector('[data-sg-discount-note]');
    var otNote = section.querySelector('[data-sg-ot-note]');

    /* Active marketing discount (set by sg-discount.js). When present and this section
       has a pre-rendered set for it, use that set; otherwise fall back to default pricing. */
    function activeDiscount() {
      return (window.SG && window.SG.discount) || null;
    }
    function sourcePackages() {
      var d = activeDiscount();
      if (d && d.codeHash && data.discounts && data.discounts[d.codeHash]) return data.discounts[d.codeHash];
      return data.packages;
    }
    /* The pricing island carries a sentinel instead of the marketing code (page source must
       not expose it); the real code comes from the visitor's own link via sg-discount.js. */
    function resolveCode(code) {
      if (code === '__SG_ACTIVE__') {
        var d = activeDiscount();
        return (d && d.code) || null;
      }
      return code;
    }
    /* Cart-permalink base: keep whatever locale prefix the SSR href already has (e.g. /en/cart/…). */
    var cartBase = '/cart/';
    if (buyLink) {
      var m = (buyLink.getAttribute('href') || '').match(/^(.*\/cart\/)/);
      if (m) cartBase = m[1];
    }
    var state = { pkg: data.default, type: data.initialType || 'sub' };
    var current = null; /* the active {variantId, sellingPlanId, discountCode} — set in render() */

    initGallery(section);
    initShipping(section);

    /* ── Package selector ── */
    section.querySelectorAll('[data-sg-pkg]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.pkg = btn.getAttribute('data-sg-pkg');
        section.querySelectorAll('[data-sg-pkg]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        render();
      });
    });

    /* ── Purchase-type toggle ── */
    section.querySelectorAll('[data-sg-type]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.type = btn.getAttribute('data-sg-type');
        render();
      });
    });

    /* ── Buy now → add to cart, then go straight to checkout (with the first-order
          discount applied via /discount/{code}). The <a> href is the no-JS fallback. ── */
    if (buyLink) {
      buyLink.addEventListener('click', function (e) {
        if (!current || !current.variantId) return; /* let the fallback href handle it */
        e.preventDefault();
        if (buyLink.getAttribute('aria-busy') === 'true') return;
        buyLink.setAttribute('aria-busy', 'true');

        /* Clarity intent tags — final pre-checkout selection (no effect on cart/pricing logic). */
        if (window.sgClaritySet) {
          window.sgClaritySet('intent_type', state.type === 'sub' ? 'subscription' : 'one-time');
          window.sgClaritySet('intent_package', state.pkg);
        }

        var item = { id: current.variantId, quantity: 1 };
        if (current.sellingPlanId) item.selling_plan = current.sellingPlanId;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] }),
        })
          .then(function (r) {
            return r.ok ? r.json() : Promise.reject(r);
          })
          .then(function () {
            var dc = resolveCode(current.discountCode);
            if (dc) {
              window.location.href =
                '/discount/' + encodeURIComponent(dc) + '?redirect=' + encodeURIComponent('/checkout');
            } else {
              window.location.href = '/checkout';
            }
          })
          .catch(function () {
            buyLink.removeAttribute('aria-busy');
            window.location.href = buyLink.getAttribute('href'); /* permalink fallback */
          });
      });
    }

    function fillCard(card, info) {
      if (!card || !info) return;
      var price = card.querySelector('[data-sg-price]');
      var compare = card.querySelector('[data-sg-compare]');
      var perday = card.querySelector('[data-sg-perday]');
      var pct = card.querySelector('[data-sg-pct]');
      var days = card.querySelector('[data-sg-days]');
      if (price) price.textContent = info.price || '';
      if (compare) compare.textContent = info.compareAt || '';
      if (perday) perday.textContent = info.perDay || '';
      if (pct) {
        if (info.pct && info.pct > 5) {
          pct.textContent = '-' + Math.round(info.pct) + '%';
          pct.hidden = false;
        } else {
          pct.hidden = true;
        }
      }
      if (days && info.days != null) days.textContent = info.days + ' ';
    }

    function render() {
      var pkgData = sourcePackages()[state.pkg];
      if (!pkgData) return;
      if (discountNote) {
        var ad = activeDiscount();
        if (ad && ad.label && ad.codeHash && data.discounts && data.discounts[ad.codeHash]) {
          discountNote.textContent = ad.label;
          discountNote.hidden = false;
        } else {
          discountNote.hidden = true;
        }
      }
      fillCard(section.querySelector('[data-sg-type="sub"]'), pkgData.sub);
      fillCard(section.querySelector('[data-sg-type="one-time"]'), pkgData.oneTime);

      section.querySelectorAll('[data-sg-type]').forEach(function (c) {
        c.classList.toggle('is-active', c.getAttribute('data-sg-type') === state.type);
      });

      /* Klarna payment icon: one-time only (matches Hydrogen). */
      if (klarna) klarna.hidden = state.type === 'sub';

      /* Third trust badge: subscription-only (its copy describes the sub). */
      if (subBadge) subBadge.hidden = state.type !== 'sub';

      /* One-time first-order-discount clarifier: shown on the one-time card whenever that card
         is discounted (a discountCode is present), independent of the −% badge toggle and the
         selected type — mirrors how the sub delivery line keys off sub.subsequent. */
      if (otNote) {
        var ot = pkgData.oneTime;
        otNote.hidden = !(ot && ot.discountCode);
      }

      /* First-order delivery line: "Erste Lieferung X, danach Y je Lieferung."
         Always shown on the subscription card whenever a first-order discount is
         active (independent of the selected type) — matches Hydrogen, avoids a jump. */
      if (delivery) {
        var sub = pkgData.sub;
        if (sub && sub.subsequent) {
          if (deliveryFirst) deliveryFirst.textContent = sub.price || '';
          if (deliverySubsequent) deliverySubsequent.textContent = sub.subsequent || '';
          delivery.hidden = false;
        } else {
          delivery.hidden = true;
        }
      }

      /* Buy-now: track the active selection for the click handler + keep the
         no-JS permalink href in sync (/cart/{variant}:1?selling_plan=&discount=). */
      var active = state.type === 'sub' ? pkgData.sub : pkgData.oneTime;
      current = active || null;
      if (active && buyLink) {
        var href = cartBase + active.variantId + ':1';
        var params = [];
        if (active.sellingPlanId) params.push('selling_plan=' + encodeURIComponent(active.sellingPlanId));
        var hrefCode = resolveCode(active.discountCode);
        if (hrefCode) params.push('discount=' + encodeURIComponent(hrefCode));
        if (params.length) href += '?' + params.join('&');
        buyLink.setAttribute('href', href);
      }
    }

    document.addEventListener('sg:discount', function () {
      render();
    });

    render();
  }

  function boot() {
    document.querySelectorAll('[data-section="offer"]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
